(function() {

    'use strict';

    angular.module('app').
    controller('ApiAccessController', ApiAccessController);

    ApiAccessController.$inject = ['$location', '$scope', 'ApiAccessClientListTableService', 'Windows', 'ClientService'];

    function ApiAccessController($location, $scope, ApiAccessClientListTableService, Windows, ClientService) {

        var vm = this;

        init();

        function init() {
            vm.clientList = ApiAccessClientListTableService;
        }
    }

})();


// WEBPACK FOOTER //
// ./js/controllers/ApiAccessController.js